import { head, isNil, last } from '@antv/util';
import interval from '../util/interval';
import pretty from '../util/pretty';
import strictLimit from '../util/strict-limit';
/**
 * è®¡ç®çº¿æ§ç ticksï¼ä½¿ç¨ R's pretty æ¹æ³
 * @param cfg åº¦éçéç½®é¡¹
 * @returns è®¡ç®åç ticks
 */
export default function linearPretty(cfg) {
    var min = cfg.min, max = cfg.max, tickCount = cfg.tickCount, tickInterval = cfg.tickInterval, minLimit = cfg.minLimit, maxLimit = cfg.maxLimit;
    var ticks = pretty(min, max, tickCount).ticks;
    if (!isNil(minLimit) || !isNil(maxLimit)) {
        return strictLimit(cfg, head(ticks), last(ticks));
    }
    if (tickInterval) {
        return interval(min, max, tickInterval).ticks;
    }
    return ticks;
}
//# sourceMappingURL=r-prettry.js.map